import React, { useEffect, useContext } from 'react';
import firebase from 'firebase';
import { Formik, Form } from 'formik';
import { object, string } from 'yup';

import { UserContext } from '../context/User';
import TextField from '../components/TextField';

const Login = ({ history }) => {
  const { isLoading, user } = useContext(UserContext);

  useEffect(() => {
    if (!isLoading && !!user) {
      history.push('/orders');
    }
  }, [history, isLoading, user])

  const handleFormSubmit = async ({ email, password }) => {
    try {
      const data = await firebase.auth().signInWithEmailAndPassword(email, password);
      const { user } = data;
      const currentUser = await firebase.database().ref(`users/${user.uid}`).once('value');

      if (currentUser && currentUser.val().role === 'admin') {
        history.push('/orders');
      } else if (currentUser && currentUser.val().role === 'user') {
        firebase.auth().signOut();
        throw { message: 'Please login with an admin account.' }
      }
    } catch (error) {
      alert(error.message);
    }
  }

  return (
    <div className="row">
      {isLoading 
        ? <h3>Loading...</h3>
        : (
          <div className="col-xs-12 col-lg-6">
            <h3 className="page-header">Login</h3>
            <Formik
              initialValues={{ email: '', password: '' }}
              validationSchema={object().shape({
                email: string().email().required(),
                password: string().required(),
              })}
              onSubmit={handleFormSubmit}
            >
              {({ handleSubmit }) => (
                <Form onSubmit={handleSubmit}>
                  <TextField type="email" label="Email Address" name="email" />
                  <TextField type="password" label="Password" name="password" />
                  <button type="submit" className="btn btn-primary">Sign In</button>
                  <a className="forgot-password" href="/recover-password">Forgot Password?</a>
                </Form>
              )}
            </Formik>
          </div>
        )}
    </div>
  );
}

export default Login;
